<template>
  <a-main-button
    :font-small="fontSmall"
    :border-radius-small="borderRadiusSmall"
    :to="voteFormTo"
    class="vote-button__wrapper"
    v-on="$listeners"
    @click="handleClick"
  >
    <slot />
  </a-main-button>
</template>

<script>
import { PROP_TYPES, propValidator } from '@fmpedia/validators'
import AMainButton from 'shared/AMainButton/index.vue'
import { mapGetters } from 'vuex'
import { MODAL } from 'modals/AModalWrapper/enums'
import { ROUTE, ROUTE_NAME } from 'enums/routes'
import { ELEMENT_ID, ELEMENT_SELECTOR_BY_ELEMENT_ID } from 'enums/element-id'

const VOTE_FORM_PATH_BY_ROUTE_NAME = {
  [ROUTE_NAME.VOTING]: ROUTE.VOTING,
  [ROUTE_NAME.CEO_VOTING]: ROUTE.CEO_VOTING
}

export default {
  name: 'AVoteButton',
  components: { AMainButton },
  props: {
    fontSmall: propValidator([PROP_TYPES.BOOLEAN], false, false),
    borderRadiusSmall: propValidator([PROP_TYPES.BOOLEAN], false, false)
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn'
    }),
    voteFormTo() {
      return {
        path: VOTE_FORM_PATH_BY_ROUTE_NAME[this.$route.name] || ROUTE.VOTING,
        hash: ELEMENT_SELECTOR_BY_ELEMENT_ID[ELEMENT_ID.VOTE_FORM]
      }
    }
  },
  methods: {
    handleClick() {
      if (!this.isLoggedIn) {
        this.$helper.openModal(MODAL.AUTH)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.vote-button__wrapper {
  text-decoration: none;
}
</style>
